import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavbarService } from './services/navbar.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { StepNavigatorService } from '../multi-step-navigator/components/step-navigator/services/step-navigator.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ForgotPasswordComponent } from 'src/app/features/modal/components/forgot-password/forgot-password.component';
import { SafeUrl } from '@angular/platform-browser';
import { FaqService } from '../../services/faq.service';
import { PermissionService } from '../../services/permission.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  public shouldShowSuperiorButtons: boolean = false;
  urlBlobPdf: SafeUrl;

  constructor(
    private authService: AuthService,
    private navbarService: NavbarService,
    private stepNavigatorService: StepNavigatorService,
    private dialog: MatDialog,
    private faqService: FaqService,
    private permissionService: PermissionService,
    private navigationService: NavigationService
  ) { }

  private username: string;
  ngOnInit() {
    this.username = this.authService.username;

    let subRefresh = this.stepNavigatorService.refreshed$
      .subscribe((refreshed) => {
        if (refreshed) {
        this.takeShouldSuperirorButtons();
        }
      });

    this.subscriptions.push(subRefresh);

    let subFaq = this.urlBlobPdf = this.faqService.obterUrlBlob()
      .subscribe(url => this.urlBlobPdf = url);

    this.subscriptions.push(subFaq);
  }

  takeShouldSuperirorButtons() {
    let sub = this.stepNavigatorService.mode()
      .subscribe(mode => {
        this.shouldShowSuperiorButtons = mode == 'single';
      });

    this.subscriptions.push(sub);
  }

  /**
   * Avoid Memory leaks
   */
  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }

  alterarSenha(): MatDialogRef<ForgotPasswordComponent> {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.data = {
        acaoAreaLogada: true
      };
      
      const dialog = this.dialog.open(ForgotPasswordComponent, dialogConfig);

      return dialog;
  }

  navigateToEditorApp(): void{
    const tokenLogin = this.authService.tokenLogin;
    this.navigationService.navigateToEditorApp(tokenLogin);
  }

  get icon(): string {
    return this.navbarService.isMobileMenuOpened ? 'close' : 'menu';
  }

  get grettingName(): string {

    if (this.username.length < 16)
      return this.username;

    if (this.username.includes(' ')) {
      const firstname = this.username.split(" ")[0];

      if (firstname.length < 16)
        return firstname;
      return firstname.substring(0, 15) + "...";
    }
    return this.username.substring(0, 15) + "...";
  }

  get hasPermissionBulkUpdates(): boolean {
    return this.permissionService.hasAreaPermissionOf('ManutencoesLote')
  }

}
